export function isAuthorNull(author: string | null) {
    return author === null ? "" : author
}
